import styles from '../index.scss'

export type IDpBusinessCommodityPrice = {
  detail?: {
    exchangePrice?: string | number // 价格
    pointPrice?: string | number // 兑换价格
    redeemUnit?: string // 租户单位
    exchangeType?: number // 支付类型
    exchangePriceSuffix?: boolean // 支付类型
    currencySymbol?: string // 币种符号
    [key: string]: any
  }
  enableCashStyle?: boolean // 积分+现金品类样式开关（cash 需求，只限卡券+实物）
}

// 1、现金 -- 展示现金
// 2、积分 -- 展示积分 + 单位
// 3、权益免费使用 -- 不展示
// 4、第三方权益支付 -- 展示积分 + 单位
// 5、积分 + 现金 -- 展示积分 + 现金
// 8、现金 + 第三方权益支付 -- 展示现金
const amountPriceMap = (props: IDpBusinessCommodityPrice) => {
  const { detail, enableCashStyle } = props
  const cs = detail?.currencySymbol || '¥'
  const csCls = styles['dp-business-commodity--cashSymbol']
  const cpCls = styles['dp-business-commodity--cashPriceNum']
  return {
    1: (
      <span>
        {!!detail?.listPrice && (
          <span className={styles['dp-business-commodity--base-listPrice']}>
            {detail?.listPrice}元
          </span>
        )}
        {!!detail?.exchangePricePrefixText && (
          <span className={styles['dp-business-commodity--base-startText']}>
            {detail?.exchangePricePrefixText}&nbsp;
          </span>
        )}
        {enableCashStyle ? (
          <>
            <span className={csCls}>{cs}</span>
            <span className={cpCls}>{Number(detail?.exchangePrice).toFixed(2)}</span>
          </>
        ) : (
          <>
            {detail?.exchangePrice}
            <span className={styles['dp-business-commodity--priceUnit']}>元</span>
          </>
        )}
        {!!detail?.exchangePriceSuffix && (
          <span className={styles['dp-business-commodity--base-startText']}>
            {detail?.exchangePriceSuffixText || '起'}
          </span>
        )}
      </span>
    ),
    8: (
      <span>
        {!!detail?.listPrice && (
          <span className={styles['dp-business-commodity--base-listPrice']}>
            {detail?.listPrice}元
          </span>
        )}
        {!!detail?.exchangePricePrefixText && (
          <span className={styles['dp-business-commodity--base-startText']}>
            {detail?.exchangePricePrefixText}&nbsp;
          </span>
        )}
        {enableCashStyle ? (
          <>
            <span className={csCls}>{cs}</span>
            <span className={cpCls}>{Number(detail?.exchangePrice).toFixed(2)}</span>
            <span className={styles['dp-business-commodity--cashPlus']}>{'+'}</span>
            <span className={cpCls}>{Math.round(Number(detail?.pointPrice) || 0)}</span>
            <span className={csCls}>{detail?.redeemUnit || '积分'}</span>
          </>
        ) : (
          <>
            {detail?.exchangePrice}
            <span className={styles['dp-business-commodity--priceUnit']}>元</span>
          </>
        )}
        {!!detail?.exchangePriceSuffix && (
          <span className={styles['dp-business-commodity--base-startText']}>
            {detail?.exchangePriceSuffixText || '起'}
          </span>
        )}
      </span>
    ),
    2: enableCashStyle ? (
      <span>
        <span className={cpCls}>{Math.round(Number(detail?.pointPrice) || 0)}</span>
        <span className={csCls}>
          {detail?.redeemUnit || '积分'}
        </span>
        {!!detail?.exchangePriceSuffix && (
          <span className={styles['dp-business-commodity--base-startText']}>
            {detail?.exchangePriceSuffixText || '起'}
          </span>
        )}
      </span>
    ) : (
      <span>
        {Math.round(Number(detail?.pointPrice) || 0)}
        <span className={styles['dp-business-commodity--priceUnit']}>
          {detail?.redeemUnit || '积分'}
        </span>
        {!!detail?.exchangePriceSuffix && (
          <span className={styles['dp-business-commodity--base-startText']}>
            {detail?.exchangePriceSuffixText || '起'}
          </span>
        )}
      </span>
    ),
    4: enableCashStyle ? (
      <span>
        <span className={cpCls}>{Math.round(Number(detail?.pointPrice) || 0)}</span>
        <span className={csCls}>
          {detail?.redeemUnit || '积分'}
        </span>
        {!!detail?.exchangePriceSuffix && (
          <span className={styles['dp-business-commodity--base-startText']}>
            {detail?.exchangePriceSuffixText || '起'}
          </span>
        )}
      </span>
    ) : (
      <span>
        {Math.round(Number(detail?.pointPrice) || 0)}
        <span className={styles['dp-business-commodity--priceUnit']}>
          {detail?.redeemUnit || '积分'}
        </span>
        {!!detail?.exchangePriceSuffix && (
          <span className={styles['dp-business-commodity--base-startText']}>
            {detail?.exchangePriceSuffixText || '起'}
          </span>
        )}
      </span>
    ),
    5: enableCashStyle ? (
      <span>
        <span className={csCls}>{cs}</span>
        <span className={cpCls}>{Number(detail?.exchangePrice).toFixed(2)}</span>
        <span className={styles['dp-business-commodity--cashPlus']}>{'+'}</span>
        <span className={cpCls}>{Math.round(Number(detail?.pointPrice) || 0)}</span>
        <span className={csCls}>
          {detail?.redeemUnit || '积分'}
        </span>
        {!!detail?.exchangePriceSuffix && (
          <span className={styles['dp-business-commodity--base-startText']}>
            {detail?.exchangePriceSuffixText || '起'}
          </span>
        )}
      </span>
    ) : (
      // master 原始：exchangeType=5 在 cash 之前基本是硬编码"元"，没有 currencySymbol
      <span>
        {detail?.exchangePrice || '0'}
        <span className={styles['dp-business-commodity--priceUnit']}>元</span>
        <span className={styles['dp-business-commodity--cashPlus']}>{'+'}</span> 元
        {Math.round(Number(detail?.pointPrice) || 0)}
        <span className={styles['dp-business-commodity--priceUnit']}>
          {detail?.redeemUnit || '积分'}
        </span>
        {!!detail?.exchangePriceSuffix && (
          <span className={styles['dp-business-commodity--base-startText']}>
            {detail?.exchangePriceSuffixText || '起'}
          </span>
        )}
      </span>
    ),
  }
}

export default amountPriceMap
